import { clsx } from "clsx";

import OnboardingProgress from "./OnboardingProgress";

import type { ReactNode } from "react";

interface NavItemProps {
  isExpanded: boolean;
  isActive?: boolean;
  isInteractive?: boolean;
  isOnboarding?: boolean;
  children: ReactNode;
  icon: ReactNode;
}

export default function NavItem({
  isExpanded,
  icon,
  isActive = false,
  isInteractive = true,
  isOnboarding = false,
  children,
}: NavItemProps) {
  const isCollapsedOnboarding = isOnboarding && !isExpanded;

  return (
    <div
      className={clsx(
        "group flex items-center justify-start gap-x-2 rounded-3xl transition-[background,shadow,border] text-nowrap",
        "max-lg:text-button-md",
        "lg:border lg:overflow-hidden lg:rounded-xl",

        isCollapsedOnboarding
          ? "size-9 justify-center items-center p-1.5"
          : "w-full h-14 lg:h-9 p-2.5",

        isActive
          ? "bg-black-800 lg:bg-white shadow-[0_3px_6px_2px_rgba(17,24,39,0.20)] lg:border-black-100 lg:text-xs-bold"
          : [
              "lg:text-xs-medium lg:border-transparent",
              isInteractive &&
                "lg:hover:border-black-200 lg:hover:bg-black-200",
            ],
      )}
    >
      {!isCollapsedOnboarding && (
        <>
          {/* Icon */}
          <span
            className={clsx(
              "[&_svg]:size-5 lg:[&_svg]:size-4 shrink-0",
              isActive ? "max-lg:text-white" : "max-lg:text-black-600",
            )}
          >
            {icon}
          </span>

          {/* Content */}
          <span
            className={clsx(
              "flex items-center transition-opacity duration-500 grow",
              isExpanded ? "opacity-100" : "opacity-0",
              isActive ? "max-lg:text-white" : "max-lg:text-black-500",
            )}
          >
            {children}
          </span>
        </>
      )}

      {isOnboarding && <OnboardingProgress />}
    </div>
  );
}
